<h3>Issues
  <ng-container *ngIf="!newIssueVisible()">
    <button (click)="newIssue()" id="new_issue_button">New Issue</button>
  </ng-container>
  <span>
    <label for="issue_status" class="for">Filter status: </label>
    <select class="form-control"  id="issue_status" required name="status" [(ngModel)]="issueStatusFilter" (change)="refresh(issueStatusFilter)">
      <!--option value="-2">Issues Not Closed</option-->
      <!--option value="-1">All Issues</option-->
      <!--option value="0">Default View</option-->
      <option value="5">All</option>
      <option value="1">All Open</option>
      <option *ngFor="let status of issue_statuses" [value]="status.issue_status_id"> {{status.issue_status_text}} </option>
    </select>
  </span>
  <span>
    <label for="issue_priority" class="for">Filter priority: </label>
    <select class="form-control"  id="issue_priority" required [(ngModel)]="issuePriorityFilter" name="priority" (change)="filterIssues()">
      <option value="-1">All Priorities</option>
      <option *ngFor="let priority of issue_priorities" [value]="priority.id"> {{priority.description}} </option>
    </select>
  </span>
  <span>
    <label for="issue_search" class="for">Search: </label>
    <input #issueSearchBox id="issue_search" (keyup)="search(issueSearchBox.value)" placeholder="Search..."/>
  </span>
</h3>
<ng-container *ngIf="newIssueVisible()">
<new-issue
    [inHub]="hub"
    [issue_sources]="issue_sources"
    [issue_statuses]="issue_statuses"
    [issue_priorities]="issue_priorities"
    [action_types]="action_types"
    (issue_saved)="onIssueSaved($event)"></new-issue>
</ng-container>
<div *ngIf="!!hubIssues && hubIssues.length > 0; else noissues" style="display:block">
  <ul class="issue_actions">
    <li>
      <button (click)="later()" class="secret"><span class="created center">Newer</span></button>
      <span class="priority_text">Pri</span>
      <ng-container *ngIf="!hub">
        <span class="hubid">Hub ID</span>
        <span class="name">Name</span>
        <span class="zone">Zone</span>
      </ng-container>
      <span class="source_text">Source</span>
      <span class="status_text">Status</span>
      <span class="actioned">Last Action</span>
      <span class="action_due">Action Due</span>
      <span class="tag">Tag</span>
      <span class="tag">Action Required</span>
      <span class="zone">Follow Up Required</span>
      <!--span class="title">Title</span-->
    </li>
    <li *ngFor="let issue of hubIssues"
        [style.background-color]="this.getColorFor(issue)">
      <span (click)="this.expandIssue(issue.issue_id)" style="display:block">
        <span class="created"> {{issue.created | godate}} </span>
        <span class="priority_text"> {{issue.priority_text}} </span>
        <ng-container *ngIf="!hub">
          <span class="hubid" (click)="gotoHub(issue.hubid)"> {{issue.hubid}} </span>
          <span class="name" (click)="gotoHub(issue.hubid)"> {{issue.hub_name}} </span>
          <span class="zone" (click)="gotoHub(issue.hubid)"> {{issue.hub_zone}} </span>
        </ng-container>
        <span class="source_text"> {{issue.source_text}} </span>
        <span class="status_text"> {{issue.status_text}} </span>
        <span class="actioned"> {{issue.last_action | godate}} </span>
        <span class="action_due"> {{issue.action_due | godate}} </span>
        <span class="tag"> {{getTagType(issue.issue_tag_id)}} </span>
        <span class="tag"> {{getActionType(issue.issue_action_id)}} </span>
        <span class="zone"> {{followUp(issue.customer_followup)}} </span>
        <!--ng-container *ngIf="expanded !== issue.issue_id">
          <span class="title"> {{issue.title}} </span>
        </ng-container-->
      </span>
      <ng-container *ngIf="expanded === issue.issue_id" style="display:block">
        <expanded-issue
          [inHub]="hub"
          [issue]="issue"
          [issue_sources]="issue_sources"
          [issue_statuses]="issue_statuses"
          [issue_priorities]="issue_priorities"
          [issue_tags]="issue_tag"
          [issue_tag_actions]="issue_action_type"
          [action_types]="action_types"
          (issue_saved)="onIssueSaved($event)"
          (minimised)="onIssueMinimised($event)"></expanded-issue>
      </ng-container>
    </li>
    <li>
      <button (click)="earlier()" class="secret"><span class="created center">Older</span></button>
      <ng-container *ngIf="!hub"><span class="hubid">Hub ID</span></ng-container>
      <span class="priority_text">Pri</span>
      <span class="source_text">Source</span>
      <span class="status_text">Status</span>
      <span class="actioned">Last Action</span>
      <span class="action_due">Action Due</span>
      <span class="tag">Tag</span>
      <span class="tag">Action Required</span>
      <span class="zone">Follow Up Required</span>
      <!--span class="title">Title</span-->
    </li>
  </ul>
</div>
<ng-template #noissues>
  No issues :-)
</ng-template>
